import { cn } from "utils";
import { EdgenModalCreateAble } from "../../EdgenModal";
import { AlphaPickPricingModalCallableParams } from "./types";
import { RetainModalContent } from "./RetainModalContent";

export const PricingRetainModalCallable = async (
  params: AlphaPickPricingModalCallableParams & {
    retainModalCopyOverrides?: {
      title?: string;
      subtitle?: string;
      features?: string[];
      userData?: Array<{ value: number; label: string }>;
      price?: Array<{
        value: number | string;
        label: string;
        discount?: number;
      }>;
    };
  },
) => {
  const {
    isPC = false,
    onClose,
    onNavigateAway,
    signal: _signal,
    ...rest
  } = params;

  const handleClose = () => {
    onClose?.();
    EdgenModalCreateAble.end(false);
  };
  // 与 AlphaPickPricingModalCallable 同约定：导航类动作只关弹窗，不执行调用方 onClose 副作用
  const handleNavigateAway = () => {
    onNavigateAway?.();
    EdgenModalCreateAble.end(false);
  };
  const result = await EdgenModalCreateAble.call({
    children: (
      <RetainModalContent
        isPc={isPC}
        {...rest}
        onClose={handleClose}
        onNavigateAway={handleNavigateAway}
      />
    ),
    containerClassName: cn(
      "bg-background_solid_neutral_primary",
      isPC ? "w-[480px] h-[712px]" : "w-full h-100vh",
    ),
    contentStyle: {
      borderRadius: isPC ? 16 : 0,
      width: isPC ? 480 : "100%",
      height: isPC ? 712 : "100%",
      padding: 0,
      overflow: "hidden",
    },
    containerStyle: {
      maxHeight: "100%",
    },
    destroyOnClose: true,
    onCancel: handleClose,
    showClose: false,
  });

  return result;
};
